import { useLoggedInUser } from "components/LoggedInUserProvider";
import React from "react";

import TrainerHorseListPage from "./Trainer";
import VetHorseListPage from "./Vet";

const HorseListsPage = () => {
  const { currentUser } = useLoggedInUser();

  if (
    currentUser.isVeterinarian ||
    currentUser.isRacingOfficial ||
    currentUser.isAdmin
  ) {
    return <VetHorseListPage />;
  }

  if (currentUser.isTrainer) {
    return <TrainerHorseListPage />;
  }

  return <></>;
};

export default HorseListsPage;
